import { render, staticRenderFns } from "./StatisticAnggota.vue?vue&type=template&id=089223bd&"
import script from "./StatisticAnggota.vue?vue&type=script&lang=js&"
export * from "./StatisticAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports